import { render, staticRenderFns } from "./Pbxzsz.vue?vue&type=template&id=4c350166&scoped=true&"
import script from "./Pbxzsz.vue?vue&type=script&lang=js&"
export * from "./Pbxzsz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c350166",
  null
  
)

export default component.exports